/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg viewBox="0 0 688 146" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <defs>
          <clipPath id="fd68f723-5fa5-420a-9aaa-9bcb2b7fe43c">
            <path fill="none" d="M0 0h688v146H0z"/>
          </clipPath>
        </defs>
        <g clipPath="url(#fd68f723-5fa5-420a-9aaa-9bcb2b7fe43c)">
          <path fill="#0e497b" d="M0 0h688v146H0z"/>
          <path fill="none" stroke="#ffb81c" d="M203.5 72h96.75" strokeWidth="4"/>
          <path fill="#0e497b" d="M203.5 72h96.75"/>
          <path fill="none" stroke="#ffb81c" d="M203.5 72h96.75M298.56 70.63A45.53 45.53 0 0 1 344 27.5 45.5 45.5 0 1 1 298.5 73q0-1.2.06-2.37M390 72h93" strokeWidth="4"/>
          <path fill="#0e497b" d="M390 72h93"/>
          <path fill="none" stroke="#ffb81c" d="M390 72h93" strokeWidth="4"/>
          <g fill="none" stroke="#83d4f1" strokeWidth="5">
            <path d="m320 72 18 18 27.75-29.75"/>
            <path d="m320 72 18 18 27.75-29.75"/>
          </g>
          <path fill="none" stroke="#fff" d="M84.5 141s-1.62-19.38 7-26c11.25-8.64 43.25-16.25 43.25-16.25a31 31 0 0 0 21 7.25 46.21 46.21 0 0 0 22-6.75s33.5 6 44.25 15.5c7 6.21 6.75 25.5 6.75 25.5" strokeWidth="5"/>
          <path d="M156.05 90.25C141.94 90.25 130.79 72 129.4 55c-3 .34-6.23.61-9.63.78l-.27-4.91c41-2.13 51.59-17.57 51.69-17.73l1.89-2.87 2.23 2.63c6.86 8.15 6.19 20.18 6.16 20.69 0 17.62-10.21 36.66-25.42 36.66Zm-21.61-35.93c1.14 15.81 11.47 31 21.61 31 10.84 0 20.34-14.91 20.34-31.91 0-.22.45-8.44-3.28-14.93-4.36 4.27-15.39 12.34-38.67 15.84Z" fill="#fff"/><path d="M133.7 92.25c-13.18-22.66-16-48.4-6.95-64.07 6-10.42 16.79-15.93 31.18-15.93 13.27 0 23.51 5.41 29.61 15.62 9.44 15.78 7.44 41-5.07 64.31l-4.34-2.33c11.72-21.8 13.75-45.13 5.19-59.45-5.17-8.65-14-13.22-25.39-13.23-12.71 0-21.76 4.53-26.91 13.47-8.05 14-5.2 38.29 6.94 59.14ZM173.56 117.57l-17.83 1 27.43-12Z" fill="#fff"/><path d="m141.44 117.57 17.84 1-27.44-12Z" fill="#fff"/>
          <path fill="none" stroke="#fff" d="M449.5 141s-1.62-19.38 7-26c11.25-8.64 43.25-16.25 43.25-16.25a31 31 0 0 0 21 7.25 46.21 46.21 0 0 0 22-6.75s33.5 6 44.25 15.5c7 6.21 6.75 25.5 6.75 25.5" strokeWidth="5"/>
          <g fill="none" stroke="#fff" strokeWidth="4">
            <path d="M518.25 12.5c16 0 33.25 8 33.25 27.75C551.5 62.06 534 91 518 91c-17 0-31.75-27.44-31.75-49.25 0-20.75 18-29.25 32-29.25ZM492.12 65s3.88-11.75 4.13-12.62 9.13-1.13 16.75-3.13 17.25-8.63 17.25-8.63a17.45 17.45 0 0 0 4.25 5.5l5.5 4.13s3.38 13.25 3.88 14.37"/>
            <path d="M492.12 65s3.88-11.75 4.13-12.62 9.13-1.13 16.75-3.13 17.25-8.63 17.25-8.63a17.45 17.45 0 0 0 4.25 5.5l5.5 4.13s3.38 13.25 3.88 14.37"/>
          </g>
        </g>
      </svg>
    );
  }
}

Icon.displayName = 'GetMatchedIcon';

export default Icon;
